import Alpine from 'alpinejs';
import Splide from '@splidejs/splide';
import { initRalliesMapLazy } from './js/rallies-map.js';
import { initSlideshows, CUSTOM_SLIDESHOW_SELECTORS } from './js/slideshows.js';
import { initFigurePortraits } from './js/figure-portraits.js';

// Shared mobile nav state — used by toggle button (header.php) and drawer (footer.php)
// which live in separate parts of the DOM and cannot share an x-data parent.
Alpine.store('nav', {
  open: false,
  toggle() { this.open = !this.open; },
  close() { this.open = false; },
});

Alpine.start();

document.addEventListener('DOMContentLoaded', () => {

  // ARIA menu state — replaces old jQuery ARIA handlers
  document.querySelectorAll('[role="menubar"]').forEach((menubar) => {
    menubar.addEventListener('focusin', (e) => {
      e.target.closest('[aria-haspopup="true"]')?.setAttribute('aria-expanded', 'true');
    });
    menubar.addEventListener('focusout', (e) => {
      e.target.closest('[aria-haspopup="true"]')?.setAttribute('aria-expanded', 'false');
    });
    menubar.addEventListener('mouseover', (e) => {
      e.target.closest('[aria-haspopup="true"]')?.setAttribute('aria-expanded', 'true');
    });
    menubar.addEventListener('mouseout', (e) => {
      e.target.closest('[aria-haspopup="true"]')?.setAttribute('aria-expanded', 'false');
    });
  });

  // IntersectionObserver — replaces jQuery InView plugin
  const inviewEls = document.querySelectorAll('.on-inview');
  if (inviewEls.length) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('slide-top');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    inviewEls.forEach((el) => observer.observe(el));
  }

  // Header dark mode when #politics is under the header
  const masthead = document.getElementById('masthead');
  const politicsSection = document.getElementById('politics');
  if (masthead && politicsSection) {
    let scrollTicking = false;
    const updateHeaderDark = () => {
      const rect = politicsSection.getBoundingClientRect();
      const headerH = masthead.offsetHeight;
      masthead.classList.toggle('is-dark', rect.top <= headerH && rect.bottom > headerH);
      scrollTicking = false;
    };
    window.addEventListener('scroll', () => {
      if (!scrollTicking) {
        requestAnimationFrame(updateHeaderDark);
        scrollTicking = true;
      }
    }, { passive: true });
  }

  // Hero + gallery slideshows
  initSlideshows();
  initFigurePortraits();

  // Splide sliders — replaces Slick Slider
  const customSlideshows = CUSTOM_SLIDESHOW_SELECTORS.map((sel) => `:not(${sel})`).join('');
  document.querySelectorAll(`.splide${customSlideshows}`).forEach((el) => {
    new Splide(el, {
      type: 'loop',
      perPage: 1,
      gap: '1rem',
    }).mount();
  });

  // National Rallies map (Leaflet + OpenStreetMap)
  initRalliesMapLazy();

});

// Window resize debounce
let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    // Add resize logic here
  }, 50);
});
